// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RenamePortfolioDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-renameportfoliodialogcontainer" */ "./RenamePortfolioDialogContainer")).then((bundle)=>{
        return {
            default: bundle.RenamePortfolioDialogContainer
        };
    });
export const LazyRenamePortfolioDialogContainer = /*#__PURE__*/ lazy(RenamePortfolioDialogContainerLazyLoader);
